var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/compose/components/polls/duration-selector.tsx";
import React, { useEffect, useMemo, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Select } from 'soapbox/components/ui';
const messages = defineMessages({
  minutes: {
    "id": "intervals.full.minutes",
    "defaultMessage": "{number, plural, one {# minute} other {# minutes}}"
  },
  hours: {
    "id": "intervals.full.hours",
    "defaultMessage": "{number, plural, one {# hour} other {# hours}}"
  },
  days: {
    "id": "intervals.full.days",
    "defaultMessage": "{number, plural, one {# day} other {# days}}"
  }
});
const DurationSelector = ({
  onDurationChange
}) => {
  const intl = useIntl();
  const [days, setDays] = useState(2);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const value = useMemo(() => {
    const now = new Date();
    const future = new Date();
    now.setDate(now.getDate() + days);
    now.setMinutes(now.getMinutes() + minutes);
    now.setHours(now.getHours() + hours);
    return Math.round((now - future) / 1000);
  }, [days, hours, minutes]);
  useEffect(() => {
    if (days === 7) {
      setHours(0);
      setMinutes(0);
    }
  }, [days]);
  useEffect(() => {
    onDurationChange(value);
  }, [value]);
  return /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 gap-y-2 gap-x-2 sm:grid-cols-3",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "sm:col-span-1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Select, {
    value: days,
    onChange: event => setDays(Number(event.target.value)),
    "data-testid": "duration-selector-days",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 9
    }
  }, [...Array(8).fill(undefined)].map((_, number) => /*#__PURE__*/React.createElement("option", {
    value: number,
    key: number,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 13
    }
  }, intl.formatMessage(messages.days, {
    number
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "sm:col-span-1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Select, {
    value: hours,
    onChange: event => setHours(Number(event.target.value)),
    disabled: days === 7,
    "data-testid": "duration-selector-hours",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 9
    }
  }, [...Array(24).fill(undefined)].map((_, number) => /*#__PURE__*/React.createElement("option", {
    value: number,
    key: number,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 13
    }
  }, intl.formatMessage(messages.hours, {
    number
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "sm:col-span-1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Select, {
    value: minutes,
    onChange: event => setMinutes(Number(event.target.value)),
    disabled: days === 7,
    "data-testid": "duration-selector-minutes",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 9
    }
  }, [0, 15, 30, 45].map(number => /*#__PURE__*/React.createElement("option", {
    value: number,
    key: number,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83,
      columnNumber: 13
    }
  }, intl.formatMessage(messages.minutes, {
    number
  }))))));
};
export default DurationSelector;